<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    transition="dialog-transition"
    content-class="errorDialog"
    :persistent="persistent"
  >
    <v-card>
      <v-card-title class="error white--text" style="font-size: 25px">
        <v-icon left large color="white">fa-exclamation-circle</v-icon>
        發生錯誤
      </v-card-title>
      <v-card-text class="pa-5 text-center" @click="persistent ? '' : dialog = false">
        <span v-for="item in items">
          <template v-if="typeof item == 'string'">
            {{ item }}
          </template>
          <template v-else-if="'type' in item">
            <v-btn rounded dark color="pink" class="d-block mt-4 mx-auto" @click="item.action(); dialog = false">
              {{ item.text }}
            </v-btn>
          </template>
          <template v-else>
            <router-link :to="item.link" v-if="'link' in item">{{ item.text }}</router-link>
            <a @click.stop="item.action" v-if="'action' in item">{{ item.text }}</a>
          </template>
        </span>
      </v-card-text>
    </v-card>
  </v-dialog>    
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      items: [],
      persistent: false
    }
  },
  created() {
    this.$root.$on('errorDialog', this.setValue)
  },
  beforeDestroy() {
    this.$root.$off('errorDialog', this.setValue)
  },
  methods: {
    setValue(items, persistent=false) {
      this.dialog = true
      this.items = items
      this.persistent = persistent
    }
  }
}

</script>

<style lang="scss" scoped>
.errorDialog {
  a {
    color: #1976d2 !important;
  }
}
</style>